import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceVenueSearchData} from "../../customer-instance-venue/customer-instance-venue-search.data";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs";

@Component({
    selector: "fhm-venue-select-control",
    templateUrl: "./venue-select-control.component.html",
    styleUrls: ["./venue-select-control.component.scss"],
    standalone: false
})
export class VenueSelectControlComponent implements OnChanges, OnInit {

    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    @Input() label: string;

    @Input() disabled: boolean;

    public selectedValue: any;

    public options: any[] = [];

    constructor( private http: HttpClient,
                 private auth: AuthApiService,
                 private errorHandler: ErrorHandlerService) {
    }

    ngOnInit(): void {
        this.http.get<CustomerInstanceVenueSearchData[]>("/fonzie/customer-instance-venues", {headers: this.auth.getHttpHeaderOptions()})
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe(data => {
                data.forEach(venue => {
                    const record = {label: venue.name, value: venue.id};
                    this.options.push(record);

                    if (venue.id === this.value) {
                        this.selectedValue = record;
                    }
                });
            });
    }

    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = undefined;
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }
}
